// FILE: users/UserDelete.js
import React from 'react';
import { Button, useDelete, useNotify, useRefresh } from 'react-admin';
import DeleteIcon from '@material-ui/icons/Delete';

export const UserDeleteButton = ({ record }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  if (!record) return null;

  const [deleteOne, { loading }] = useDelete(//eslint-disable-line
    'users', // resource name
    { id: record.id }, // id of the record to be deleted
    record, // previous record to provide optimistic update
    {
      onSuccess: () => {
        notify('Usuário deletado com sucesso', 'info');
        refresh();
      },
      onFailure: (error) => notify(`Erro ao deletar usuário: ${error.message}`, 'warning'),
    }
  );

  return (
    <Button
      onClick={deleteOne}
      disabled={loading}
      label="Deletar"
    >
      <DeleteIcon />
    </Button>
  );
};
